export const getDefaultValues = (mediaSocialPlayerDetails) => ({
  MediaSocialPlayerTitle: mediaSocialPlayerDetails?.MediaSocialPlayerTitle || '',
  MediaSocialPlayerImageCover: mediaSocialPlayerDetails?.MediaSocialPlayerImageCover || '',
  MediaSocialPlayerImageThumbnail: mediaSocialPlayerDetails?.MediaSocialPlayerImageThumbnail || '',
  MediaSocialPlayerHLS: mediaSocialPlayerDetails?.MediaSocialPlayerHLS || '',
  MediaSocialPlayerClickUrl: mediaSocialPlayerDetails?.MediaSocialPlayerClickUrl || '',
  MediaSocialPlayerVastUrl: mediaSocialPlayerDetails?.MediaSocialPlayerVastUrl || '',
  MediaSocialPlayerOrderIndex: mediaSocialPlayerDetails?.MediaSocialPlayerOrderIndex || 0,
});
